/* sg-reviews — "Mehr anzeigen" progressive reveal + per-card "Weiterlesen" expand
   (vanilla, progressive enhancement).
   - Card reveal: shows the next batch of already-rendered review cards per click (no network);
     hides the button once the rendered sample is exhausted.
   - Read-more: each review body is clamped (.is-clamped). A body is only measured while its card
     is visible, so we measure the initial cards at init and the extra cards the moment they're
     revealed — never a display:none element (which reports 0 height). The "Weiterlesen" toggle is
     revealed only when the text actually overflows; clicking it unclamps that body and hides the toggle.
   No-JS falls back to all cards shown and all bodies unclamped (see the <noscript> blocks in the section). */
(function () {
  // Reveal a card's "Weiterlesen" toggle if its clamped body is actually truncated.
  // Safe to call only while the card is visible (a hidden element reports 0 height).
  function measureCard(card) {
    var body = card.querySelector('[data-sg-review-body]');
    var toggle = card.querySelector('[data-sg-review-toggle]');
    if (!body || !toggle) return;
    if (body.classList.contains('is-clamped') && body.scrollHeight > body.clientHeight) {
      toggle.hidden = false;
    }
  }

  function init(section) {
    // ── Per-card "Weiterlesen": unclamp on click, hide the toggle (one-way, like the card reveal) ──
    Array.prototype.slice.call(section.querySelectorAll('[data-sg-review-toggle]')).forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var card = toggle.closest('.sg-rev__card');
        var body = card && card.querySelector('[data-sg-review-body]');
        if (body) body.classList.remove('is-clamped');
        toggle.hidden = true;
      });
    });
    // Measure the cards that are visible right now (the initial batch; extras are measured on reveal).
    Array.prototype.slice.call(section.querySelectorAll('.sg-rev__card:not([data-sg-extra])')).forEach(measureCard);

    // ── "Mehr anzeigen" progressive card reveal ──
    var btn = section.querySelector('[data-sg-reviews-more]');
    if (!btn) return;
    var extras = Array.prototype.slice.call(section.querySelectorAll('[data-sg-extra]'));
    if (!extras.length) {
      if (btn.parentNode) btn.parentNode.style.display = 'none';
      return;
    }
    var step = parseInt(btn.getAttribute('data-sg-step'), 10) || 4;
    var shown = 0;
    btn.addEventListener('click', function () {
      for (var i = 0; i < step && shown < extras.length; i++, shown++) {
        extras[shown].classList.add('is-shown');
        measureCard(extras[shown]); // now visible — its body height is finally measurable
      }
      if (shown >= extras.length && btn.parentNode) btn.parentNode.style.display = 'none';
    });
  }

  Array.prototype.slice.call(document.querySelectorAll('[data-sg-reviews]')).forEach(init);
})();
